import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel } from '../../models/ValuableModel'

export class SchemaMapModel extends ValuableModel {
  @fromNode()
  @reactive('deep')
  entries?: [any, any][]
}

declare global {
  export interface RehajeViewModels {
    'Schema.Map': SchemaMapModel
  }
}
